import React, { AnchorHTMLAttributes } from 'react';

type AnchorLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  children: React.ReactNode;
  anchorRef?;
};

const AnchorLink = ({ children, anchorRef = null, ...otherProps }: AnchorLinkProps) => {
  return (
    <a {...otherProps} ref={anchorRef} rel="noopener noreferrer">
      {children}
    </a>
  );
};

export default AnchorLink;
